module.exports = __webpack_public_path__ + "img/kefu.6b9ad598.png";